import { Factory } from 'rosie';

Factory.define('AutoAcceptedSessionNotification');

Factory.define('AutoAcceptedSessionNotificationWithDefaults')
  .extend('AutoAcceptedSessionNotification')
  .attr('type', 'AUTO_ACCEPTED_SESSION_NOTIFICATION')
  .attr('profile', () => Factory.attributes('SessionCustomerWithDefaults'))
  .attr('conversationId', 'conversation-id')
  .attr('id', 'queue-item-id')
  .attr('messageText', '')
  .attr('sessionType', 'SMS');



// WEBPACK FOOTER //
// ./factories/auto_accepted_session_notification_factory.js